<script>
import firebase from 'firebase'
import { mapActions } from 'vuex'
import { emailRule } from '../../helpers/validationRules'

export default {
  name: 'ForgotPassword',
  metaInfo: {
    title: 'Forgot Password',
    titleTemplate: '%s | LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          'LinkBook.io makes life easier to find and access your favourite websites instantly with the bookmark network hub.'
      }
    ]
  },
  data() {
    return {
      email: null,
      feedback: null,
      success: null,
      emailRule
    }
  },
  methods: {
    ...mapActions(['login']),
    submit() {
      if (this.email) {
        const auth = firebase.auth()
        auth
          .sendPasswordResetEmail(this.email)
          .then(() => {
            this.success =
              'Email sent!, if your email exists you will receive an email to reset your password.'

            this.feedback = null

            this.$notify({
              type: 'success',
              group: 'action',
              title: this.success
            })
          })
          .catch(error => {
            console.error('Password reset error:', error)

            this.feedback = `Sorry an error has occurred, ${error.message}`
            this.success = null

            this.$notify({
              type: 'error',
              group: 'action',
              title: this.feedback
            })
          })
      } else {
        this.feedback = 'Email is required'
        this.success = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  max-width: 400px;
  margin-top: 60px;
  h2 {
    font-size: 2.4em;
  }
  .field {
    margin-bottom: 16px;
  }
}
</style>

<template>
  <v-card width="400" class="mx-auto mt-16">
    <v-card-title>
      <h1 class="display-1">Forgot Password</h1>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field
          name="email"
          label="Email"
          v-model="email"
          prepend-icon="mdi-email"
          :rules="emailRule"
          required
        />

        <p v-if="success" class="my-3 green--text center">{{ success }}</p>
        <p v-if="feedback" class="my-3 red--text center">{{ feedback }}</p>

        <v-divider class="my-3"></v-divider>

        <v-card-actions>
          <v-btn text to="/login">Back to Login</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="submit" color="primary">Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>
